export default __webpack_public_path__ + "static/media/edit.a5e0633d.svg";